import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

import doctorImageUrl from '../assets/DrRogersOffice.png';
const ReviewSection = styled.section`
  padding: 4rem 2rem;
  background-color: #ffffff;
`;

const ContentWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 4rem;

  @media (max-width: 992px) {
    flex-direction: column-reverse; /* Puts text below image on mobile */
    text-align: left;
    gap: 2rem;
  }
`;

const TextContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  font-size: 2.25rem;
  color: #333;
  margin-bottom: 2rem;
  line-height: 1.3;

  @media (max-width: 992px) {
    font-size: 1.8rem;
    text-align: center; /* Keep the title centered */
  }
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 1rem;

  svg {
    color: #005eb8;
    margin-right: 0.75rem;
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  @media (max-width: 992px) {
    /* Use default (flex-start) for left alignment */
  }
`;

const ImageWrapper = styled.div`
  flex: 0 0 350px; /* Give a fixed base width */
  max-width: 350px;

  @media (max-width: 992px) {
    max-width: 250px; /* Make it smaller on mobile */
  }
`;

const DoctorImage = styled.img`
  width: 100%;
  display: block;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 5px solid white;
`;

const DoctorReview = () => {
  const features = [
    'UK based doctor',
    'GMC registered doctor',
    '10+ years of medical experience',
    "Governed by the GMC's - good medical practice",
  ];

  return (
    <ReviewSection>
      <ContentWrapper>
        <ImageWrapper>
          <DoctorImage src={doctorImageUrl} alt="Dr. Mathew Rogers" />
        </ImageWrapper>
        <TextContent>
          <SectionTitle>All applications are reviewed by our director, who is a UK based and experienced doctor</SectionTitle>
          <FeaturesList>
            {features.map((feature, index) => (
              <FeatureItem key={index}>
                <FaCheckCircle />
                <span>{feature}</span>
              </FeatureItem>
            ))}
          </FeaturesList>
        </TextContent>
      </ContentWrapper>
    </ReviewSection>
  );
};

export default DoctorReview;